import { render, staticRenderFns } from "./EchartsFour.vue?vue&type=template&id=feb16b20&scoped=true&"
import script from "./EchartsFour.vue?vue&type=script&lang=js&"
export * from "./EchartsFour.vue?vue&type=script&lang=js&"
import style0 from "./EchartsFour.vue?vue&type=style&index=0&id=feb16b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb16b20",
  null
  
)

export default component.exports